// Collection pages: header and filter bar slide away while scrolling down and come back (sticky) on scroll up
(function () {
  const HIDDEN_CLASS = 'collection-header-hidden';
  const TOLERANCE = 10;

  const body = document.body;
  let destroy = null;

  function init() {
    const facets = document.querySelector('.collection > .collection-facets');
    if (!facets) return null;

    const collection = facets.parentElement;
    const header = document.getElementById('header');
    const headerSection = header && header.closest('.shopify-section');
    let lastScrollY = Math.max(window.scrollY, 0);
    let ticking = false;

    // Measured here rather than taken from --header-height, which global.js only refreshes on scroll/resize
    // and can stay a few pixels off once the header settles, leaving a gap above the filter bar
    // The facets height is set on the collection so the sidebar filters can offset by it too
    function setHeights() {
      const isHeaderSticky = headerSection && getComputedStyle(headerSection).position === 'sticky';
      const headerHeight = isHeaderSticky ? headerSection.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--sticky-header-height', `${headerHeight}px`);
      collection.style.setProperty('--collection-facets-height', `${facets.offsetHeight}px`);
    }

    // Drawers, mega menu and the filter drawer must never slide away while they are open
    function isLocked() {
      return (
        body.classList.contains('drawer--is-open') ||
        body.style.overflow === 'hidden' ||
        body.style.position === 'fixed' ||
        (header && header.classList.contains('is-megamenu-open')) ||
        facets.querySelector('details[open]') !== null
      );
    }

    // Stuck once the bar has been pushed down from its natural spot at the top of the collection
    function setStuck() {
      const naturalOffset = parseFloat(getComputedStyle(collection).paddingTop) || 0;
      const offset = facets.getBoundingClientRect().top - collection.getBoundingClientRect().top;
      facets.classList.toggle('is-stuck', offset > naturalOffset + 1);
    }

    function update() {
      ticking = false;
      setStuck();
      // iOS rubber band scrolling reports negative values
      const scrollY = Math.max(window.scrollY, 0);
      const delta = scrollY - lastScrollY;
      if (Math.abs(delta) < TOLERANCE) return;
      lastScrollY = scrollY;
      if (isLocked()) return;

      // Keep everything in place until the filter bar has been scrolled past
      const facetsEnd = collection.getBoundingClientRect().top + scrollY + facets.offsetHeight;
      body.classList.toggle(HIDDEN_CLASS, delta > 0 && scrollY > facetsEnd);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    // Keyboard focus must never land on the header or filter bar while they are off-screen (WCAG 2.4.11)
    function onFocusIn(event) {
      if ((header && header.contains(event.target)) || facets.contains(event.target)) {
        body.classList.remove(HIDDEN_CLASS);
      }
    }

    setHeights();
    setStuck();
    let resizeObserver = null;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(setHeights);
      resizeObserver.observe(facets);
      if (headerSection) resizeObserver.observe(headerSection);
    } else {
      window.addEventListener('resize', setHeights);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('focusin', onFocusIn);

    return function () {
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', setHeights);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('focusin', onFocusIn);
      body.classList.remove(HIDDEN_CLASS);
    };
  }

  function reset() {
    if (destroy) destroy();
    destroy = null;
  }

  destroy = init();

  // Theme editor: the collection or header section is re-rendered, so the cached elements go stale
  document.addEventListener('shopify:section:unload', reset);
  document.addEventListener('shopify:section:load', () => {
    reset();
    destroy = init();
  });
})();
